import { useEffect, useId } from 'react';

// Set de IDs únicos de instancias que están bloqueando el scroll
// Usar Set evita problemas de contadores y permite debugging
const activeLocks = new Set<string>();

const updateBodyScroll = () => {
  if (typeof document === 'undefined') return;
  document.body.style.overflow = activeLocks.size > 0 ? 'hidden' : '';
};

export const useBodyScrollLock = (isLocked: boolean) => {
  const isBrowser = typeof window !== 'undefined';
  const lockId = useId();

  useEffect(() => {
    if (!isBrowser) return;

    if (isLocked) {
      activeLocks.add(lockId);
    } else {
      activeLocks.delete(lockId);
    }
    updateBodyScroll();

    return () => {
      activeLocks.delete(lockId);
      updateBodyScroll();
    };
  }, [isLocked, isBrowser, lockId]);
};
